import posthog from 'posthog-js'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
  api_host: 'https://s.hireanautist.com',
  capture_exceptions: true,
  debug: process.env.NODE_ENV === 'development',
  defaults: '2026-01-30',
  person_profiles: 'always',
  ui_host: 'https://us.posthog.com',
})
